var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"page-transition"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading-container",class:{ '--over-nav': _vm.overNav }},[_c('AppLoader')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }